export default "__VITE_ASSET__JzbMSCeN__"